import React from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const defaultOptions = {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};

export class ToastifyHelper {
    static info(message, options = {}) {
        toast.info(
            <div className="p-3 s20">
                <FontAwesomeIcon icon="info-circle" className="branco r10" />
                {message}
            </div>,
            {
                ...defaultOptions,
                ...options,
            }
        );
    }

    static warning(message, options = {}) {
        toast.warn(
            <div className="p-3 s20">
                <FontAwesomeIcon
                    icon="exclamation-triangle"
                    className="branco r10"
                />
                {message}
            </div>,
            {
                ...defaultOptions,
                ...options,
                hideProgressBar: false,
                style: {
                    background: '#ffc107',
                    color: '#ffffff',
                    ...(options.style || {}),
                },
                progressClassName: `toast-warning-progress ${
                    options.progressClassName || ''
                }`.trim(),
                progressStyle: {
                    background: '#863434',
                    height: '5px',
                    ...(options.progressStyle || {}),
                },
            }
        );
    }

    static success(message, options = {}) {
        toast.success(
            <div className="p-3 s20">
                <FontAwesomeIcon icon="check-circle" className="branco r10" />
                {message}
            </div>,
            {
                ...defaultOptions,
                ...options,
            }
        );
    }

    static error(message, options = {}) {
        toast.error(
            <div className="p-3 s20">
                <FontAwesomeIcon icon="times-circle" className="branco r10" />
                {message}
            </div>,
            {
                ...defaultOptions,
                ...options,
            }
        );
    }
}